import moment from 'moment';

import type {
  DateRange,
  Session,
  TimestampInMillis,
} from '@cobliteam/common-types';

const medianSpeedPartialReleaseFleetIds = [
  '6eee9cb9-82d3-403b-8a2f-5d13b387f316',
  '15249426-7c76-42c4-9a3c-f262a55ed31d',
  '2f232403-0413-4189-aff7-de0d86020950',
  '8f1b3806-3584-4007-bdeb-64a4aced226a',
  '7e52b091-2d87-4ed3-9550-fc283d5c395b',
  'd7a89c30-0cb7-449b-8c99-4f210a37297e',
];

const medianSpeedPartialReleaseDate = new Date(2023, 8, 5);
export const medianSpeedFullReleaseDate = new Date(2024, 2, 1);

export const isFleetInMedianSpeedPartialReleaseBatch = (session: Session) =>
  medianSpeedPartialReleaseFleetIds.includes(session.fleet.id);

export const isEventBasedOnMedianSpeed = (
  session: Session,
  eventTime: TimestampInMillis
) => {
  if (isFleetInMedianSpeedPartialReleaseBatch(session)) {
    return eventTime >= medianSpeedPartialReleaseDate.getTime();
  }

  return eventTime >= medianSpeedFullReleaseDate.getTime();
};

export const periodContainsReleaseDate = (
  session: Session,
  period: DateRange
) => {
  if (isFleetInMedianSpeedPartialReleaseBatch(session)) {
    return (
      period.start <= medianSpeedPartialReleaseDate.getTime() &&
      period.end >= medianSpeedPartialReleaseDate.getTime()
    );
  }

  return (
    period.start <= medianSpeedFullReleaseDate.getTime() &&
    period.end >= medianSpeedFullReleaseDate.getTime()
  );
};

export const periodBeforeReleaseDate = (
  session: Session,
  period: DateRange
) => {
  if (isFleetInMedianSpeedPartialReleaseBatch(session)) {
    return period.end < medianSpeedPartialReleaseDate.getTime();
  }

  return period.end < medianSpeedFullReleaseDate.getTime();
};

export const getReleaseDate = (session: Session) => {
  if (isFleetInMedianSpeedPartialReleaseBatch(session)) {
    return medianSpeedPartialReleaseDate;
  }

  return medianSpeedFullReleaseDate;
};

export const formatTimeFromMinutes = (value: number) => {
  const time = moment.duration(value, 'minutes');
  const hours = Math.floor(time.asHours());
  const hourItem = hours > 0 ? `${hours} h ` : '';
  const minItem = `${time.minutes()} min`;
  return hourItem + minItem;
};
